<div [formGroup]="parentGroup" class="grid"> <!-- style="align-items: center;"> -->
  <abbr class="req-label" i18n-title="@@main.alt.required" title="Pflicht">*</abbr>
  <div class="form-group span-12 profile-image">
    <div class="avatar0">
      <app-avatar-selector (selectionChange)="setAvatar(avatars[0])" [checked]="profileImage === avatars[0]"
        [src]="avatars[0]"
        name="avatar-group"
      number="1"></app-avatar-selector>
    </div>
    <div class="avatar1">
      <app-avatar-selector (selectionChange)="setAvatar(avatars[1])" [checked]="profileImage === avatars[1]"
        [src]="avatars[1]"
        name="avatar-group"
      number="2"></app-avatar-selector>
    </div>
    <div class="avatar2">
      <app-avatar-selector (selectionChange)="setAvatar(avatars[2])" [checked]="profileImage === avatars[2]"
        [src]="avatars[2]"
        name="avatar-group"
      number="3"></app-avatar-selector>
    </div>
    <div class="avatar3">
      <app-avatar-selector (selectionChange)="setAvatar(avatars[3])" [checked]="profileImage === avatars[3]"
        [src]="avatars[3]"
        name="avatar-group"
      number="4"></app-avatar-selector>
    </div>
    <div class="custom">
      <app-profile-image-selector #profileImageSelector
        (srcChange)="setCustomProfileImage($event)"
        [src]="customProfileImage">
      </app-profile-image-selector>
    </div>

    @if (profileImageControl.invalid && (profileImageControl.touched || profileImageControl.dirty)) {
      <div
        class="validation error span-12" i18n="@@shared.recipientProfile.error.profileImage">Bitte wählen Sie Ihr
            Profilbild aus.
        </div>
    }
  </div>

  <div class="form-group span-6">
    <label class="label" for="input-firstname">
      <ng-container i18n="@@shared.recipientProfile.input.firstName">Vorname</ng-container>
      <abbr class="req-label" i18n-title="@@main.alt.required" title="Pflicht">*</abbr>
    </label>
    <input class="input" formControlName="first" id="input-firstname"
      maxlength="40"
      type="text">
    @if (firstControl.invalid && (firstControl.touched || firstControl.dirty)) {
      <div
        class="validation error" i18n="@@shared.recipientProfile.error.firstName">Bitte geben Sie Ihren Vornamen
            ein.
        </div>
    }
  </div>
  <div class="form-group span-6">
    <label class="label" for="input-name">
      <ng-container i18n="@@shared.recipientProfile.input.secondName">Name (wird nicht veröffentlicht)
            </ng-container>
      <abbr class="req-label" i18n-title="@@main.alt.required" title="Pflicht">*</abbr>
    </label>
    <input class="input" formControlName="name" id="input-name"
      maxlength="40"
      type="text">
    @if (nameControl.invalid && (nameControl.touched || nameControl.dirty)) {
      <div
        class="validation error" i18n="@@shared.recipientProfile.error.secondName">Bitte geben Sie Ihren Nachnamen
            ein.
        </div>
    }
  </div>
</div>
